




































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import BuildingData from '@/ts/BuildingData';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class BuildingList extends Vue {
    public tableEntity: string = 'BuildingList';
    public selectedBuildings: any = [];

    constructor() {
        super();
    }

    get defaultTableConfig(): TableViewConfig {
        return {
             visibleColumns: [
                'id',
                'name',
                'numberOfProperties',
            ],
        };
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.unit-group-id', 'Unit Group ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'name', label: this.$t('general.group-name', 'Group name'), align: 'left', field: 'name', sortable: true, required: false },
            { name: 'numberOfProperties', label: this.$t('general.properties', 'Properties'), align: 'left', field: 'numberOfProperties', sortable: true, required: false },
        ];
    }

    get tableConfig(): any {
        return this.$store.getters['TableConfigs/getBuildingListTableConfig'];
    }

    get paginationOptions(): number {
        return this.tableConfig.config.per_page;
    }

    get tableVisibleColumns(): string[] {
        return this.tableConfig.config.visible_columns;
    }

    get getSelectedBuildings() {
        return this.filteredBuildings.filter((item: any) => item.selected);
    }

    get filteredBuildings() {
        const activeProject = this.$store.state.Projects.activeProjectId;
        const allBuildings = this.$store.getters['Buildings/allBuildings'].filter((building: BuildingData) => building.persisted);

        if (activeProject === null) {
            return allBuildings;
        }

        return allBuildings.filter((building: BuildingData) => building.projectId === activeProject);
    }

    public selectItem(id: number) {
        const allBuildings = this.$store.getters['Buildings/allBuildings'];
        allBuildings.forEach((building: any) => {
            this.$store.commit(Mutations.DESELECT_BUILDING, building.id);
        });
        this.$store.commit(Mutations.SELECT_BUILDING, id);
        this.$router.push({path: '/admin/units'});
    }

    public toggleItem(buildings: any) {
        const allBuildings = this.$store.getters['Buildings/allBuildings'];
        const buildingIds = buildings.map((building: BuildingData) => building.id);

        allBuildings.forEach((building: any) => {
            if (buildingIds.includes(building.id)) {
                this.$store.commit(Mutations.SELECT_BUILDING, building.id);
            } else {
                this.$store.commit(Mutations.DESELECT_BUILDING, building.id);
            }
        });
    }

    public deleteBuilding(itemId: number): void {
      this.$store.dispatch(Actions.DELETE_BUILDING, itemId);
    }

    public slideInForm(formKey: string, itemId: number) {
        this.$store.commit(Mutations.UPDATE_ACTIVE_BUILDING, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_BUILDING);
        this.$store.commit(Mutations.SHOW_EDIT_BUILDING_FORM, formKey);
    }

    public created() {
        this.selectedBuildings = this.getSelectedBuildings;
    }
}
